import * as api from 'registration/resources/registration.api';
import actionTypes from './action-types';

export const fetchOwnerValidationMethodRequest = () => ({
  type: actionTypes.FETCH_OWNER_VALIDATION_METHOD_REQUEST,
  isLoading: true,
});

export const fetchOwnerValidationMethodSuccess = (ownerValidationMethod) => ({
  type: actionTypes.FETCH_OWNER_VALIDATION_METHOD_SUCCESS,
  isLoading: false,
  ownerValidationMethod,
});

export const fetchOwnerValidationMethodFailure = () => ({
  type: actionTypes.FETCH_OWNER_VALIDATION_METHOD_FAILURE,
  isLoading: false,
});

export const fetchOwnerValidationMethod =
  (retailerType, outletTypeId, locale = '*') =>
  async (dispatch) => {
    try {
      dispatch(fetchOwnerValidationMethodRequest());
      const { values } = await api.fetchOwnerValidationMethod(retailerType, outletTypeId, locale);
      dispatch(fetchOwnerValidationMethodSuccess(values));
    } catch (error) {
      console.error('FETCH_OWNER_VALIDATION_METHOD', error);
      dispatch(fetchOwnerValidationMethodFailure());
    }
  };



// WEBPACK FOOTER //
// ./src/modules/registration/actions/fetch-owner-validation.actions.js